import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface SelectedRowContextProps {
  selectedClientRow: number | null;
  setClientRow: (index: number | null) => void;
}

const SelectedClientRowContext = createContext<SelectedRowContextProps | undefined>(undefined);

interface SelectedRowProviderProps {
  children: ReactNode;
}

export const SelectedClientRowProvider: React.FC<SelectedRowProviderProps> = ({ children }) => {
  const [selectedClientRow, setSelectedClientRow] = useState<number | null>(
    JSON.parse(localStorage?.getItem('selectedClientRow') || 'null')
  );

  const setClientRow = (index: number | null) => {
    setSelectedClientRow(index);
  };

  useEffect(() => {
    if (selectedClientRow !== null) {
      localStorage?.setItem('selectedClientRow', JSON.stringify(selectedClientRow));
    } else {
      localStorage?.removeItem('selectedClientRow');
    }
  }, [selectedClientRow]);

  const contextValue: SelectedRowContextProps = {
    selectedClientRow,
    setClientRow,
  };

  return (
    <SelectedClientRowContext.Provider value={contextValue}>
      {children}
    </SelectedClientRowContext.Provider>
  );
};

export const useSelectedClientRow = (): SelectedRowContextProps => {
  const context = useContext(SelectedClientRowContext);
  if (!context) {
    throw new Error('useSelectedClientRow must be used within a SelectedClientRowProvider');
  }
  return context;
};
